import FuseUtils from '@fuse/utils';
import AppContext from 'app/AppContext';
import { useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function FuseAuthorization({ children }) {
const location = useLocation();
const navigate = useNavigate();
const { routes } = useContext(AppContext);
const userRole = useSelector(({ auth }) => auth.user.role);
const { pathname, state } = location;

const accessGranted = useMemo(() => {
const matched = matchRoutes(routes, pathname);
if (matched && matched.length > 0) {
return FuseUtils.hasPermission(matched[0].route.auth, userRole);
}
return true;
}, [routes, pathname, userRole]);

useEffect(() => {
if (!accessGranted) {
const redirectUrl = state?.redirectUrl ? state.redirectUrl : '/';

if (!userRole || userRole.length === 0) {
navigate('/auth/login', { state: { redirectUrl: pathname } });
} else {
navigate(redirectUrl);
}
}
}, [accessGranted, userRole, pathname, state, navigate]);

return accessGranted ? children : null;
}

FuseAuthorization.propTypes = {
  children: PropTypes.node,
};

export default FuseAuthorization;
